<template>
    <div class="flex">
        <label
            :for="name"
            class="checkbox-container"
        >
            <input
                :class="classes"
                :id="name"
                :name="name"
                type="checkbox"
                :checked="value"
                @input="$emit('input', value ? '' : 'On')"
                @click="$emit('click', $event)"
            >
            <span
                class="checkmark"
                aria-hidden="true"
            ></span>
        </label>
        <p class="text-sm ml-8">
            <slot></slot>
        </p>
    </div>
</template>

<script>
export default {
    props: ["name", "classes", "value"],
};
</script>

<style>
</style>